import type { FeedbackKind } from "./api";

export const OPEN_FEEDBACK_EVENT = "wikiparty:feedback";

export interface FeedbackPrefill {
  kind?: FeedbackKind;
  message?: string;
  /** Longer text shown read-only and sent along, e.g. an error message. */
  code?: string;
  /** Short facts for the maintainers, e.g. { Lobby: "abc123" }. */
  context?: Record<string, string>;
}

/** Opens the feedback panel from anywhere, optionally filled in. */
export function openFeedback(prefill: FeedbackPrefill = {}) {
  window.dispatchEvent(
    new CustomEvent<FeedbackPrefill>(OPEN_FEEDBACK_EVENT, { detail: prefill }),
  );
}
